module.exports = __webpack_public_path__ + "media/images/tmp/ig4-d6c95751946602c743c03d01727d0e0c.png";